import { render, staticRenderFns } from "./SoundSettings.vue?vue&type=template&id=7e46884e"
import script from "./SoundSettings.vue?vue&type=script&lang=js"
export * from "./SoundSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports